import adyenV2Bcmc from '../../../../svg/component/paymentOptions/adyenV2Bcmc.svg';
import adyenV2BcmcPillow from '../../../../svg/component/paymentOptions/adyenV2BcmcPillow.svg';
import adyenV2Billdesk_upi from '../../../../svg/component/paymentOptions/adyenV2Billdesk_upi.svg';
import adyenV2Billdesk_upiPillow from '../../../../svg/component/paymentOptions/adyenV2Billdesk_upiPillow.svg';
import adyenV2Billdesk_wallet from '../../../../svg/component/paymentOptions/adyenV2Billdesk_wallet.svg';
import adyenV2Billdesk_walletPillow from '../../../../svg/component/paymentOptions/adyenV2Billdesk_walletPillow.svg';
import adyenV2Ideal from '../../../../svg/component/paymentOptions/adyenV2Ideal.svg';
import adyenV2IdealPillow from '../../../../svg/component/paymentOptions/adyenV2IdealPillow.svg';
import adyenV2Mobilepay from '../../../../svg/component/paymentOptions/adyenV2Mobilepay.svg';
import adyenV2MobilepayPillow from '../../../../svg/component/paymentOptions/adyenV2MobilepayPillow.svg';
import adyenV2Molpay_ebanking_fpx_MY from '../../../../svg/component/paymentOptions/adyenV2Molpay_ebanking_fpx_MY.svg';
import adyenV2Molpay_ebanking_fpx_MYPillow
from '../../../../svg/component/paymentOptions/adyenV2Molpay_ebanking_fpx_MYPillow.svg';
import adyenV2OnlineBanking_PL from '../../../../svg/component/paymentOptions/adyenV2OnlineBanking_PL.svg';
import adyenV2OnlineBanking_PLPillow from '../../../../svg/component/paymentOptions/adyenV2OnlineBanking_PLPillow.svg';
import adyenV2Paytm from '../../../../svg/component/paymentOptions/adyenV2Paytm.svg';
import adyenV2PaytmPillow from '../../../../svg/component/paymentOptions/adyenV2PaytmPillow.svg';
import adyenV2Payu_IN_nb from '../../../../svg/component/paymentOptions/adyenV2Payu_IN_nb.svg';
import adyenV2Payu_IN_nbPillow from '../../../../svg/component/paymentOptions/adyenV2Payu_IN_nbPillow.svg';
import adyenV2Sepadirectdebit from '../../../../svg/component/paymentOptions/adyenV2Sepadirectdebit.svg';
import adyenV2SepadirectdebitPillow from '../../../../svg/component/paymentOptions/adyenV2SepadirectdebitPillow.svg';
import adyenV2Sofort from '../../../../svg/component/paymentOptions/adyenV2Sofort.svg';
import adyenV2SofortPillow from '../../../../svg/component/paymentOptions/adyenV2SofortPillow.svg';
import adyenV2Swish from '../../../../svg/component/paymentOptions/adyenV2Swish.svg';
import adyenV2SwishPillow from '../../../../svg/component/paymentOptions/adyenV2SwishPillow.svg';
import adyenV2Wallet_IN from '../../../../svg/component/paymentOptions/adyenV2Wallet_IN.svg';
import adyenV2Wallet_INPillow from '../../../../svg/component/paymentOptions/adyenV2Wallet_INPillow.svg';
import afterpayPillow from '../../../../svg/component/paymentOptions/afterpay-pillow.svg';
import afterpay from '../../../../svg/component/paymentOptions/afterpay.svg';
import afterpayUSPillow from '../../../../svg/component/paymentOptions/afterpayUS-pillow.svg';
import afterpayUS from '../../../../svg/component/paymentOptions/afterpayUS.svg';
import alipayPlusPillow from '../../../../svg/component/paymentOptions/alipay-plus-pillow.svg';
import alipayPlus from '../../../../svg/component/paymentOptions/alipay-plus.png';
import alipayPlusAuCurrency from '../../../../svg/component/paymentOptions/alipay-plus-au-currency.png';
import alipayPlusCollapsed from '../../../../svg/component/paymentOptions/alipay-plus-collapsed.svg';
import amazonpay from '../../../../svg/component/paymentOptions/amazonpay.svg';
import amazonpayPillow from '../../../../svg/component/paymentOptions/amazonpay-pillow.svg';
import amexPillow from '../../../../svg/component/paymentOptions/amex-pillow.svg';
import amex from '../../../../svg/component/paymentOptions/amex.svg';
import applepayPillow from '../../../../svg/component/paymentOptions/applepay-pillow.svg';
import applepay from '../../../../svg/component/paymentOptions/applepay.svg';
import arvatoPillow from '../../../../svg/component/paymentOptions/arvato-pillow.svg';
import arvato from '../../../../svg/component/paymentOptions/arvato.svg';
import atomePillow from '../../../../svg/component/paymentOptions/atome-pillow.svg';
import atome from '../../../../svg/component/paymentOptions/atome.svg';
import bcmcPillow from '../../../../svg/component/paymentOptions/bcmc-pillow.svg';
import bcmc from '../../../../svg/component/paymentOptions/bcmc.svg';
import boletoPillow from '../../../../svg/component/paymentOptions/boleto-pillow.svg';
import boleto from '../../../../svg/component/paymentOptions/boleto.svg';
import cartebancairePillow from '../../../../svg/component/paymentOptions/cartebancaire-pillow.svg';
import cartebancaire from '../../../../svg/component/paymentOptions/cartebancaire.svg';
import clearpayPillow from '../../../../svg/component/paymentOptions/clearpay-pillow.svg';
import clearpay from '../../../../svg/component/paymentOptions/clearpay.svg';
import cupPillow from '../../../../svg/component/paymentOptions/cup-pillow.svg';
import cup from '../../../../svg/component/paymentOptions/cup.svg';
import dinersPillow from '../../../../svg/component/paymentOptions/diners-pillow.svg';
import diners from '../../../../svg/component/paymentOptions/diners.svg';
import directEbankingPillow from '../../../../svg/component/paymentOptions/directEbanking-pillow.svg';
import directEbanking from '../../../../svg/component/paymentOptions/directEbanking.svg';
import discoverPillow from '../../../../svg/component/paymentOptions/discover-pillow.svg';
import discover from '../../../../svg/component/paymentOptions/discover.svg';
import dotpayPillow from '../../../../svg/component/paymentOptions/dotpay-pillow.svg';
import dotpay from '../../../../svg/component/paymentOptions/dotpay.svg';
import ebankingFI from '../../../../svg/component/paymentOptions/ebanking_FI.svg';
import ebankingFIAkitaPillow from '../../../../svg/component/paymentOptions/ebanking_FI_akita-pillow.svg';
import ebankingFIAkita from '../../../../svg/component/paymentOptions/ebanking_FI_aktia.svg';
import ebankingFIAlandsbankenPillow from '../../../../svg/component/paymentOptions/ebanking_FI_alandsbanken-pillow.svg';
import ebankingFIAlandsbanken from '../../../../svg/component/paymentOptions/ebanking_FI_alandsbanken.svg';
import ebankingFIDanskeBankPillow from '../../../../svg/component/paymentOptions/ebanking_FI_danske_bank-pillow.svg';
import ebankingFIDanskeBank from '../../../../svg/component/paymentOptions/ebanking_FI_danske_bank.svg';
import ebankingFIHandelsbankenPillow
from '../../../../svg/component/paymentOptions/ebanking_FI_handelsbanken-pillow.svg';
import ebankingFIHandelsbanken from '../../../../svg/component/paymentOptions/ebanking_FI_handelsbanken.svg';
import ebankingFINordeaPillow from '../../../../svg/component/paymentOptions/ebanking_FI_nordea-pillow.svg';
import ebankingFINordea from '../../../../svg/component/paymentOptions/ebanking_FI_nordea.svg';
import ebankingFIOpBankPillow from '../../../../svg/component/paymentOptions/ebanking_FI_op_bank-pillow.svg';
import ebankingFIOpBank from '../../../../svg/component/paymentOptions/ebanking_FI_op_bank.svg';
import ebankingFIPaytrailPillow from '../../../../svg/component/paymentOptions/ebanking_FI_paytrail-pillow.svg';
import ebankingFIPaytrail from '../../../../svg/component/paymentOptions/ebanking_FI_paytrail.svg';
import ebankingFIPopBankFinlandPillow
from '../../../../svg/component/paymentOptions/ebanking_FI_pop_bank_finland-pillow.svg';
import ebankingFIPopBankFinland from '../../../../svg/component/paymentOptions/ebanking_FI_pop_bank_finland.svg';
import ebankingFIPopBankSwedenPillow
from '../../../../svg/component/paymentOptions/ebanking_FI_pop_bank_sweden-pillow.svg';
import ebankingFIPopBankSweden from '../../../../svg/component/paymentOptions/ebanking_FI_pop_bank_sweden.svg';
import ebankingFISaastopankkiPillow from '../../../../svg/component/paymentOptions/ebanking_FI_saastopankki-pillow.svg';
import ebankingFISaastopankki from '../../../../svg/component/paymentOptions/ebanking_FI_saastopankki.svg';
import econtextSevenElevenPillow from '../../../../svg/component/paymentOptions/econtext_seven_eleven-pillow.svg';
import econtextSevenEleven from '../../../../svg/component/paymentOptions/econtext_seven_eleven.svg';
import econtextStores from '../../../../svg/component/paymentOptions/econtext_stores.svg';
import econtextStoresCircleKPillow from '../../../../svg/component/paymentOptions/econtext_stores_circleK-pillow.svg';
import econtextStoresCircleK from '../../../../svg/component/paymentOptions/econtext_stores_circleK.svg';
import econtextStoresFamilyMartPillow
from '../../../../svg/component/paymentOptions/econtext_stores_family_mart-pillow.svg';
import econtextStoresFamilyMart from '../../../../svg/component/paymentOptions/econtext_stores_family_mart.svg';
import econtextStoresLawsonPillow from '../../../../svg/component/paymentOptions/econtext_stores_lawson-pillow.svg';
import econtextStoresLawson from '../../../../svg/component/paymentOptions/econtext_stores_lawson.svg';
import econtextStoresMiniStopPillow
from '../../../../svg/component/paymentOptions/econtext_stores_mini_stop-pillow.svg';
import econtextStoresMiniStop from '../../../../svg/component/paymentOptions/econtext_stores_mini_stop.svg';
import econtextStoresSeicomartPillow
from '../../../../svg/component/paymentOptions/econtext_stores_seicomart-pillow.svg';
import econtextStoresSeicomart from '../../../../svg/component/paymentOptions/econtext_stores_seicomart.svg';
import eloPillow from '../../../../svg/component/paymentOptions/elo-pillow.svg';
import epsPillow from '../../../../svg/component/paymentOptions/eps-pillow.svg';
import eps from '../../../../svg/component/paymentOptions/eps.svg';
import giropayPillow from '../../../../svg/component/paymentOptions/giropay-pillow.svg';
import giropay from '../../../../svg/component/paymentOptions/giropay.svg';
import googlepayPillow from '../../../../svg/component/paymentOptions/googlepay-pillow.svg';
import googlepay from '../../../../svg/component/paymentOptions/googlepay.svg';
import hiperPillow from '../../../../svg/component/paymentOptions/hiper-pillow.svg';
import hummPillow from '../../../../svg/component/paymentOptions/humm-pillow.svg';
import humm from '../../../../svg/component/paymentOptions/humm.svg';
import idealPillow from '../../../../svg/component/paymentOptions/ideal-pillow.svg';
import ideal from '../../../../svg/component/paymentOptions/ideal.svg';
import interacPillow from '../../../../svg/component/paymentOptions/interac-pillow.svg';
import interac from '../../../../svg/component/paymentOptions/interac.svg';
import jcbPillow from '../../../../svg/component/paymentOptions/jcb-pillow.svg';
import jcb from '../../../../svg/component/paymentOptions/jcb.svg';
import kcpBankPillow from '../../../../svg/component/paymentOptions/kcp_bank-pillow.svg';
import kcpBank from '../../../../svg/component/paymentOptions/kcp_bank.svg';
import kcpBanktransfer from '../../../../svg/component/paymentOptions/kcp_banktransfer.svg';
import kcpCardPillow from '../../../../svg/component/paymentOptions/kcp_card-pillow.svg';
import kcpCard from '../../../../svg/component/paymentOptions/kcp_card.svg';
import kcpCreditCard from '../../../../svg/component/paymentOptions/kcp_creditcard.svg';
import klarnaPillow from '../../../../svg/component/paymentOptions/klarna-pillow.svg';
import klarna from '../../../../svg/component/paymentOptions/klarna.svg';
import klarnaLaterPillow from '../../../../svg/component/paymentOptions/klarna_later-pillow.svg';
import klarnaLater from '../../../../svg/component/paymentOptions/klarna_later.svg';
import klarnaNowPillow from '../../../../svg/component/paymentOptions/klarna_now-pillow.svg';
import klarnaNow from '../../../../svg/component/paymentOptions/klarna_now.svg';
import klarnaPaymentPillow from '../../../../svg/component/paymentOptions/klarna_payment-pillow.svg';
import klarnaPayment from '../../../../svg/component/paymentOptions/klarna_payment.svg';
import klarnaSlicePillow from '../../../../svg/component/paymentOptions/klarna_slice-pillow.svg';
import klarnaSlice from '../../../../svg/component/paymentOptions/klarna_slice.svg';
import laybuyPillow from '../../../../svg/component/paymentOptions/laybuy-pillow.svg';
import laybuy from '../../../../svg/component/paymentOptions/laybuy.svg';
import maestroPillow from '../../../../svg/component/paymentOptions/maestro-pillow.svg';
import maestro from '../../../../svg/component/paymentOptions/maestro.svg';
import mastercardPillow from '../../../../svg/component/paymentOptions/mastercard-pillow.svg';
import mastercard from '../../../../svg/component/paymentOptions/mastercard.svg';
import modePillow from '../../../../svg/component/paymentOptions/mode-pillow.svg';
import mode from '../../../../svg/component/paymentOptions/mode.gif';
import molpayEbankingMYPillow from '../../../../svg/component/paymentOptions/molpay_ebanking_MY-pillow.svg';
import molpayEbankingMY from '../../../../svg/component/paymentOptions/molpay_ebanking_MY.svg';
import monetaRu from '../../../../svg/component/paymentOptions/moneta-ru.svg';
import monetaRuPillow from '../../../../svg/component/paymentOptions/monetaRU-pillow.svg';
import multibancoPillow from '../../../../svg/component/paymentOptions/multibanco-pillow.svg';
import multibanco from '../../../../svg/component/paymentOptions/multibanco.svg';
import newpayPillow from '../../../../svg/component/paymentOptions/newpay-pillow.svg';
import newpay from '../../../../svg/component/paymentOptions/newpay.png';
import one4allPillow from '../../../../svg/component/paymentOptions/one4all-pillow.svg';
import one4all from '../../../../svg/component/paymentOptions/one4all.svg';
import openpayPillow from '../../../../svg/component/paymentOptions/openpay-pillow.svg';
import openpay from '../../../../svg/component/paymentOptions/openpay.svg';
import paypalPillow from '../../../../svg/component/paymentOptions/paypal-pillow.svg';
import paypal from '../../../../svg/component/paymentOptions/paypal.svg';
import paypal_in_3 from '../../../../svg/component/paymentOptions/paypal_in_3.svg';
import paytmPillow from '../../../../svg/component/paymentOptions/paytm-pillow.svg';
import paytm from '../../../../svg/component/paymentOptions/paytm.svg';
import payuINPillow from '../../../../svg/component/paymentOptions/payu_IN-pillow.svg';
import payuIN from '../../../../svg/component/paymentOptions/payu_IN.svg';
import payvynePillow from '../../../../svg/component/paymentOptions/payvyne-pillow.svg';
import payvyne from '../../../../svg/component/paymentOptions/payvyne.svg';
import poliPillow from '../../../../svg/component/paymentOptions/poli-pillow.svg';
import poli from '../../../../svg/component/paymentOptions/poli.svg';
import primeiropayBoleto from '../../../../svg/component/paymentOptions/primeiropay_boleto.svg';
import qiwiwalletPillow from '../../../../svg/component/paymentOptions/qiwiwallet-pillow.svg';
import qiwiwallet from '../../../../svg/component/paymentOptions/qiwiwallet.svg';
import quadpay from '../../../../svg/component/paymentOptions/quadpay.svg';
import safetypayPillow from '../../../../svg/component/paymentOptions/safetypay-pillow.svg';
import safetypay from '../../../../svg/component/paymentOptions/safetypay.svg';
import sepaPillow from '../../../../svg/component/paymentOptions/sepa-pillow.svg';
import sepa from '../../../../svg/component/paymentOptions/sepa.svg';
import sepadirectdebit from '../../../../svg/component/paymentOptions/sepadirectdebit.svg';
import sezzlePillow from '../../../../svg/component/paymentOptions/sezzle-pillow.svg';
import sezzle from '../../../../svg/component/paymentOptions/sezzle.svg';
import splititPillow from '../../../../svg/component/paymentOptions/splitit-pillow.svg';
import splitit from '../../../../svg/component/paymentOptions/splitit.svg';
import spotiiPillow from '../../../../svg/component/paymentOptions/spotii-pillow.svg';
import spotii from '../../../../svg/component/paymentOptions/spotii.svg';
import spotiiARPillow from '../../../../svg/component/paymentOptions/spotiiAR-pillow.svg';
import spotiiAR from '../../../../svg/component/paymentOptions/spotiiAR.svg';
import tenpayPillow from '../../../../svg/component/paymentOptions/tenpay-pillow.svg';
import tenpay from '../../../../svg/component/paymentOptions/tenpay.svg';
import trustlyOldPillow from '../../../../svg/component/paymentOptions/trustly-old-pillow.svg';
import trustlyOld from '../../../../svg/component/paymentOptions/trustly-old.svg';
import trustlyPillow from '../../../../svg/component/paymentOptions/trustly-pillow.svg';
import trustly from '../../../../svg/component/paymentOptions/trustly.svg';
import trustlyUK from '../../../../svg/component/paymentOptions/trustlyUK.svg';
import trustpayPillow from '../../../../svg/component/paymentOptions/trustpay-pillow.svg';
import trustpay from '../../../../svg/component/paymentOptions/trustpay.svg';
import unionpayNew from '../../../../svg/component/paymentOptions/unionpay-new.svg';
import unionpayPillow from '../../../../svg/component/paymentOptions/unionpay-pillow.svg';
import unionpay from '../../../../svg/component/paymentOptions/unionpay.svg';
import visaCreditPillow from '../../../../svg/component/paymentOptions/visa-credit-pillow.svg';
import visaCredit from '../../../../svg/component/paymentOptions/visa-credit.svg';
import visaDebitPillow from '../../../../svg/component/paymentOptions/visa-debit-pillow.svg';
import visaDebit from '../../../../svg/component/paymentOptions/visa-debit.svg';
import visaElectronPillow from '../../../../svg/component/paymentOptions/visa-electron-pillow.svg';
import visaElectron from '../../../../svg/component/paymentOptions/visa-electron.svg';
import wechatpayPillow from '../../../../svg/component/paymentOptions/wechatpay-pillow.svg';
import wechatpay from '../../../../svg/component/paymentOptions/wechatpay.svg';
import yandexMoneyPillow from '../../../../svg/component/paymentOptions/yandex_money-pillow.svg';
import yandexMoney from '../../../../svg/component/paymentOptions/yandex_money.svg';
import yandexWebmoneyPillow from '../../../../svg/component/paymentOptions/yandex_webmoney-pillow.svg';
import yandexWebmoney from '../../../../svg/component/paymentOptions/yandex_webmoney.svg';
import zippayPillow from '../../../../svg/component/paymentOptions/zippay-pillow.svg';
import zippay from '../../../../svg/component/paymentOptions/zippay.svg';
import razorpay from '../../../../svg/component/paymentOptions/razorpay.svg';
import frasersPlus from '../../../../svg/component/paymentOptions/fraserspay.svg';
import frasersPlusPillow from '../../../../svg/component/paymentOptions/fraserspayPillow.svg';
import flex from '../../../../svg/component/paymentOptions/flexpay.svg';
import flexPillow from '../../../../svg/component/paymentOptions/flexPillow.svg';

const icons = {
  'ADYEN_V2--wallet_IN': adyenV2Wallet_IN,
  'ADYEN_V2--wallet_INPillow': adyenV2Wallet_INPillow,
  'ADYEN_V2--billdesk_wallet': adyenV2Billdesk_wallet,
  'ADYEN_V2--billdesk_walletPillow': adyenV2Billdesk_walletPillow,
  'ADYEN_V2--payu_IN_nb': adyenV2Payu_IN_nb,
  'ADYEN_V2--payu_IN_nbPillow': adyenV2Payu_IN_nbPillow,
  'ADYEN_V2--billdesk_upi': adyenV2Billdesk_upi,
  'ADYEN_V2--billdesk_upiPillow': adyenV2Billdesk_upiPillow,
  'ADYEN_V2--mobilepay': adyenV2Mobilepay,
  'ADYEN_V2--mobilepayPillow': adyenV2MobilepayPillow,
  'ADYEN_V2--onlineBanking_PL': adyenV2OnlineBanking_PL,
  'ADYEN_V2--onlineBanking_PLPillow': adyenV2OnlineBanking_PLPillow,
  'ADYEN_V2--dotpay': adyenV2OnlineBanking_PL,
  'ADYEN_V2--dotpayPillow': adyenV2OnlineBanking_PLPillow,
  'ADYEN_V2--sofort': adyenV2Sofort,
  'ADYEN_V2--sofortPillow': adyenV2SofortPillow,
  'ADYEN_V2--directEbanking': adyenV2Sofort,
  'ADYEN_V2--directEbankingPillow': adyenV2SofortPillow,
  'ADYEN_V2--paytm': adyenV2Paytm,
  'ADYEN_V2--paytmPillow': adyenV2PaytmPillow,
  'ADYEN_V2--molpay_ebanking_fpx_MY': adyenV2Molpay_ebanking_fpx_MY,
  'ADYEN_V2--molpay_ebanking_fpx_MYPillow': adyenV2Molpay_ebanking_fpx_MYPillow,
  'ADYEN_V2--ebanking_FI': ebankingFIPaytrail,
  'ADYEN_V2--ebanking_FIPillow': ebankingFIPaytrail,
  'ADYEN_V2--swish': adyenV2Swish,
  'ADYEN_V2--swishPillow': adyenV2SwishPillow,
  'ADYEN_V2--bcmc': adyenV2Bcmc,
  'ADYEN_V2--bcmcPillow': adyenV2BcmcPillow,
  'ADYEN_V2--bcmc_mobile': adyenV2Bcmc,
  'ADYEN_V2--bcmc_mobilePillow': adyenV2BcmcPillow,
  'ADYEN_V2--giropay': giropay,
  'ADYEN_V2--giropayPillow': giropayPillow,
  'ADYEN_V2--trustly': trustly,
  'ADYEN_V2--trustlyPillow': trustlyPillow,
  'ADYEN_V2--sepadirectdebit': adyenV2Sepadirectdebit,
  'ADYEN_V2--sepadirectdebitPillow': adyenV2SepadirectdebitPillow,
  'ADYEN_V2--ideal': adyenV2Ideal,
  'ADYEN_V2--idealPillow': adyenV2IdealPillow,
  afterpay,
  afterpayPillow,
  afterpayUS,
  afterpayUSPillow,
  alipay_plus: alipayPlus,
  alipay_plus_au_currency: alipayPlusAuCurrency,
  alipay_plus_collapsed: alipayPlusCollapsed,
  alipay_plusPillow: alipayPlusPillow,
  amazonpay,
  amazonpayPillow,
  amex,
  amexPillow,
  applepay,
  applepayPillow,
  arvato,
  arvatoPillow,
  atome,
  atomePillow,
  bcmc,
  bcmcPillow,
  boleto,
  boletoPillow,
  cartebancaire,
  cartebancairePillow,
  clearpay,
  clearpayPillow,
  cup,
  cupPillow,
  diners,
  dinersPillow,
  directEbanking,
  directEbankingPillow,
  discover,
  discoverPillow,
  dotpay,
  dotpayPillow,
  ebanking_FI: ebankingFI,
  ebankingFIAkita,
  ebankingFIAkitaPillow,
  ebankingFIAlandsbanken,
  ebankingFIAlandsbankenPillow,
  ebankingFIDanskeBank,
  ebankingFIDanskeBankPillow,
  ebankingFIHandelsbanken,
  ebankingFIHandelsbankenPillow,
  ebankingFINordea,
  ebankingFINordeaPillow,
  ebankingFIOpBank,
  ebankingFIOpBankPillow,
  ebankingFIPaytrail,
  ebankingFIPaytrailPillow,
  ebankingFIPopBankFinland,
  ebankingFIPopBankFinlandPillow,
  ebankingFIPopBankSweden,
  ebankingFIPopBankSwedenPillow,
  ebankingFISaastopankki,
  ebankingFISaastopankkiPillow,
  econtext_seven_eleven: econtextSevenEleven,
  econtext_seven_elevenPillow: econtextSevenElevenPillow,
  econtext_stores: econtextStores,
  econtextStoresCircleK,
  econtextStoresCircleKPillow,
  econtextStoresFamilyMart,
  econtextStoresFamilyMartPillow,
  econtextStoresLawson,
  econtextStoresLawsonPillow,
  econtextStoresMiniStop,
  econtextStoresMiniStopPillow,
  econtextStoresSeicomart,
  econtextStoresSeicomartPillow,
  eloPillow,
  eps,
  epsPillow,
  giropay,
  giropayPillow,
  googlepay,
  googlepayPillow,
  hiperPillow,
  ideal,
  idealPillow,
  interac,
  interacPillow,
  jcb,
  jcbPillow,
  kcp_bank: kcpBank,
  kcp_bankPillow: kcpBankPillow,
  kcp_banktransfer: kcpBanktransfer,
  kcp_banktransferPillow: kcpBankPillow,
  kcp_card: kcpCard,
  kcp_cardPillow: kcpCardPillow,
  kcp_creditcard: kcpCreditCard,
  kcp_creditcardPillow: kcpBankPillow,
  klarna,
  klarnaPillow,
  klarna_later: klarnaLater,
  klarna_laterPillow: klarnaLaterPillow,
  klarna_now: klarnaNow,
  klarna_nowPillow: klarnaNowPillow,
  klarna_payment: klarnaPayment,
  klarna_paymentPillow: klarnaPaymentPillow,
  klarna_slice: klarnaSlice,
  klarna_slicePillow: klarnaSlicePillow,
  maestro,
  maestroPillow,
  mastercard,
  mastercardPillow,
  molpay_ebanking_MY: molpayEbankingMY,
  molpay_ebanking_MYPillow: molpayEbankingMYPillow,
  molpay_ebanking_fpx_MY: molpayEbankingMY,
  molpay_ebanking_fpx_MYPillow: molpayEbankingMYPillow,
  'moneta-ru': monetaRu,
  'moneta-ruPillow': monetaRuPillow,
  multibanco,
  multibancoPillow,
  newpay,
  newpayPillow,
  one4all,
  one4allPillow,
  paypal,
  paypal_in_3,
  paypalPillow,
  paypal_in_3Pillow: paypalPillow,
  paytm,
  paytmPillow,
  payu_IN: payuIN,
  payu_INPillow: payuINPillow,
  payvyne,
  payvynePillow,
  poli,
  poliPillow,
  primeiropay_boleto: primeiropayBoleto,
  primeiropay_boletoPillow: boletoPillow,
  qiwiwallet,
  qiwiwalletPillow,
  safetypay,
  safetypayPillow,
  sepa,
  sepaPillow,
  sepadirectdebit,
  sepadirectdebitPillow: sepaPillow,
  sepaDirectPillow: sepaPillow,
  tenpay,
  tenpayPillow,
  trustly,
  trustlyPillow,
  trustlyUK,
  trustlyUKPillow: trustlyPillow,
  'trustly-old': trustlyOld,
  'trustly-oldPillow': trustlyOldPillow,
  trustpay,
  trustpayPillow,
  unionpay,
  unionpayPillow,
  'unionpay-new': unionpayNew,
  'unionpay-newPillow': unionpayPillow,
  'visa-credit': visaCredit,
  'visa-creditPillow': visaCreditPillow,
  'visa-debit': visaDebit,
  'visa-debitPillow': visaDebitPillow,
  'visa-electron': visaElectron,
  'visa-electronPillow': visaElectronPillow,
  wechatpay,
  wechatpayPillow,
  yandex_money: yandexMoney,
  yandex_moneyPillow: yandexMoneyPillow,
  yandex_webmoney: yandexWebmoney,
  yandex_webmoneyPillow: yandexWebmoneyPillow,
  laybuy,
  laybuyPillow,
  splitit,
  splititPillow,
  openpay,
  openpayPillow,
  zippay,
  zippayPillow,
  sezzle,
  sezzlePillow,
  quadpay,
  quadpayPillow: zippayPillow,
  mode,
  modePillow,
  spotii,
  spotiiPillow,
  spotiiAR,
  spotiiARPillow,
  humm,
  hummPillow,
  razorpay,
  frasers_plus: frasersPlus,
  frasers_plusPillow: frasersPlusPillow,
  flex,
  flexPillow,
  pci_pal: null, // TODO: Add pci-pal.svg when provided by UX team
  pci_palPillow: null, // TODO: Add pci-pal-pillow.svg when provided by UX team
};

export default name => ({
  url: icons[name],
  pillowUrl: icons[`${name}Pillow`],
  name,
  // to fix Each dictionary in the list "icons" should contain a non-empty UTF8 string field "type"."
  // https://stackoverflow.com/questions/66171107/each-dictionary-in-the-list-icons-should-contain-a-non-empty-utf8-string-field
  type: name,
});
